var render = function render(){var _vm=this,_c=_vm._self._c;return _c('light',{staticClass:"w-100",attrs:{"is-switched-on":_vm.isSwitchOn,"switch-on-color":_vm.getColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }